import { MainPanel } from '@calendly/booking-kit'
import { Loader } from '@calendly/ui/components/loader'
import { useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import LayoutContainer from 'components/layout/container'
import ErrorAlert from 'components/error/alert'
import { ConfirmationPageDataWrapper, useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import { useStatsigLayer } from 'hooks/use-statsig-layer'
import { BookingStorage } from 'components/confirmation/booking-storage'

import { MeetingPollConfirmation } from './meeting_poll_confirmation'
import { Confirmation as NewConfirmation } from './new_confirmation'
import { PersonalizedConfirmation } from './personalized_confirmation'
import { ConfirmationPage as OldConfirmation } from './legacy'

const CurrentConfirmationPage = () => {
  const { useNewConfirmation } = useConfirmationPageData()

  if (useNewConfirmation) {
    return (
      <LayoutContainer expanded>
        <MainPanel>
          <NewConfirmation />
        </MainPanel>
      </LayoutContainer>
    )
  }
  return (
    <LayoutContainer expanded>
      <MainPanel>
        <OldConfirmation />
      </MainPanel>
    </LayoutContainer>
  )
}

const ConfirmationPageComponent = () => {
  const history = useHistory()
  const location = useLocation()
  const { event, eventType, currentUser, isMeetingPollFlow } = useConfirmationPageData()
  const isTwoColumnDesign = useStatsigLayer('booking_flow').get('confirmation_page_two_column_design')

  const returnPath = useMemo(() => {
    const pathMatch = location.pathname.match(/^(.*)\/invitees\//)
    return pathMatch ? pathMatch[1] : null
  }, [location.pathname])

  useEffect(() => {
    if (!returnPath) return undefined

    const unlisten = history.listen((_, action) => {
      if (action === 'POP') {
        window.location.href = returnPath
      }
    })

    return () => unlisten()
  }, [history, returnPath])
  // ───────────────────────────────────────────

  useEffect(() => { // On all confirmation pages, remove all potential past Stripe redirect stored info
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('pi_')) {
        localStorage.removeItem(key)
      }
    })
  }, [])

  if (eventType === undefined) return <Loader />
  if (event === undefined) return <Loader />
  if (event === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }
  if (isMeetingPollFlow) {
    return (
      <LayoutContainer expanded>
        <MainPanel>
          <MeetingPollConfirmation />
        </MainPanel>
      </LayoutContainer>
    )
  }
  if (currentUser) {
    return <CurrentConfirmationPage />
  }

  return isTwoColumnDesign ? <PersonalizedConfirmation /> : <CurrentConfirmationPage />
}


export const ConfirmationPage = () => (
  <ConfirmationPageDataWrapper>
    <ConfirmationPageComponent />
    <BookingStorage />
  </ConfirmationPageDataWrapper>
)
